__turbopack_context__.v({
  "articlesList": "styles-module-scss-module__yQLFHW__articlesList",
  "inner": "styles-module-scss-module__yQLFHW__inner",
  "title": "styles-module-scss-module__yQLFHW__title",
});
